import React, { useState, useEffect } from "react";

import "./styles/Home.css";

import useFetch from "../utils/useFetch";
import { AiOutlineSearch, AiOutlineEye } from "react-icons/ai";
import Player from "./Player";
import Templates from "../data/Templates";

export default function Home() {
  const [disableButtons, setDisableButtons] = useState(true);
  const [selectedplayer, setSelectedPlayer] = useState();
  const [templateId, setTemplateId] = useState(2);
  const [query, setQuery] = useState("");

  const { isLoading, error, data } = useFetch(`${query}`);

  useEffect(() => {
    setDisableButtons(!selectedplayer || !templateId);
  }, [selectedplayer, templateId]);

  const templates = Templates.templates;

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        background: "#272C34",
        color: "#ffffff",
      }}
    >
      <header className="header">
        <div className="logo">
          <img src="./logo192.png" alt="rudyairlines overlay" />
          <h1>Rudyairlines Overlay</h1>
        </div>

        <div className="preview">
          <button
            className={`${
              disableButtons ? "disable-button" : "preview-button"
            }`}
            disabled={disableButtons}
            onClick={() => {
              if (!disableButtons) {
                window.open(
                  `/?profileId=${selectedplayer}&template=${templateId}`,
                  "_blank"
                );
              }
            }}
          >
            <AiOutlineEye /> See overlay
          </button>
        </div>

        <p className="installation">
          <a href="?installation=1">How to install it?</a>
        </p>
      </header>

      <div className="container-form">
        <div className="settings-form">
          <h2>Select template:</h2>
          <div className="templates-list">
            {templates.map((template, index) => {
              return (
                <article
                  key={template.id}
                  className={`template-item ${
                    template.id === templateId && "template-item-selected"
                  }`}
                  onClick={() => setTemplateId(template.id)}
                >
                  <button type="button">
                    <img
                      src={template.image}
                      alt={template.name}
                      height="140"
                    />
                    <div className="template-description">
                      <h2>{template.name}</h2>
                      <p>{template.description}</p>
                    </div>
                    <span className="MuiCardActionArea-focusHighlight"></span>
                    <span className="MuiTouchRipple-root"></span>
                  </button>
                </article>
              );
            })}
            <article className="template-item">
              <button type="button">
                <div className="template-description custom-overlay">
                  <h2>Your own overlay!</h2>
                  <p>Do you want your own design?</p>
                  <p>Do you have an idea for an overlay?</p>
                  <p>
                    Contact me on Discord:
                    <a
                      href="https://discordapp.com/users/DK_rudyairlines#6990"
                      style={{ color: "#00bcd4", marginLeft: "8px" }}
                    >
                      rudyairlines#6990
                    </a>
                  </p>
                </div>
              </button>
            </article>
          </div>

          <h2>Select player:</h2>
          <div className="username-input">
            <div className="input-lateral-bar"></div>

            <input
              type="text"
              className="username-dropdown"
              placeholder="Write your username..."
              value={query}
              onChange={(e) => setQuery(e.target.value)}
            />

            <div className="dropdown-arrow">
              <AiOutlineSearch />
            </div>
          </div>

          <div className="users-results">
            {isLoading ? "Loading..." : ""}
            {error.show && <div className="error">{error.msg}</div>}
            {!isLoading & !error.show
              ? data !== null && data.length > 0
                ? data.map((player) => (
                    <Player
                      key={player.profile_id}
                      selected={player.profile_id === selectedplayer}
                      data={player}
                      datakey={player.profile_id}
                      setSelectedPlayer={setSelectedPlayer}
                    />
                  ))
                : ""
              : ``}
          </div>
        </div>
      </div>

      <div className="support">
        <p>If you like what I do, encourage me to keep creating nerd stuffs.</p>
        <p>You can buy me a coffee☕️!</p>
        <a
          href="https://www.buymeacoffee.com/rudyairlines"
          target="_blank"
          rel="noreferrer"
        >
          <img className="support-logo" src="./bmc-logo.png" alt="" />
        </a>
      </div>
    </div>
  );
}
